import React, { useState } from 'react';
import discordIntegrationService from '../../../services/discordIntegrationService';

const DiscordConnectPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const start = async () => {
    setLoading(true); setError(null);
    try {
      const { url, state } = await discordIntegrationService.getOAuthUrl();
      sessionStorage.setItem('discord_oauth_state', state);
      window.location.href = url; // redirect to Discord authorize
    } catch (e: any) {
      setError(e?.message || 'Failed to initiate Discord OAuth');
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-xl">
      <h1 className="text-2xl font-bold mb-4">Connect Discord</h1>
      <p className="text-gray-600 mb-6">Link your Discord account to enable automatic patron role assignment and community access sync.</p>
      {error && <div className="mb-4 text-sm text-red-600">{error}</div>}
      <button disabled={loading} onClick={start} className="bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 text-white px-6 py-3 rounded-md font-medium shadow">
        {loading ? 'Redirecting…' : 'Connect Discord'}
      </button>
      <div className="mt-6 text-sm text-gray-500">After authorization you will return here to map server roles to your tiers.</div>
    </div>
  );
};

export default DiscordConnectPage;